import { AppName } from './types';

export default {
  app: {
    favicon: `${process.env.PUBLIC_URL}/favicons/${AppName.KWT}.ico`
  },
  header: {
    image: `${process.env.PUBLIC_URL}/img/header-${AppName.KWT}.png`,
    imageAlt: 'Keyboarding Without Tears by Learning Without Tears',
    title: 'Keyboarding Without Tears®',
    backgroundColor: '#63ceca',
    textColor: '#000000',
    appNameTitle: `${AppName.KWT}`,
    displayAccessibilitySettings: false
  },
  body: {
    backgroundColor: '#cdf6f6'
  },
  buttons: {
    go: {
      backgroundColor: '#005f8d',
      textColor: '#FFF'
    }
  },
  links: {
    about: {
      href: 'https://www.lwtears.com/kwt',
      textColor: '#0057A3'
    },
    support: {
      textColor: '#0057A3'
    }
  }
};
